import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import MainMenu from "./components/Organisms/MainMenu";
import Home from "./components/Pages/Home";
import About from "./components/Pages/About";
import Portfolio from "./components/Pages/Portfolio";
import NotFound from "./components/Pages/NotFound";
import Register from "./components/Pages/Register";
import Contact from "./components/Pages/Contact";
import { AnimatePresence } from "framer-motion";
import Footer from "./components/Organisms/Footer";
import Banner from "./components/Organisms/Banner";
import BannerPages from "./components/Organisms/BannerPages";

function App() {
  const location = useLocation();

  console.log(location.pathname);
  return (
    <>
      <MainMenu />
      {location.pathname === "/" ? <Banner /> : <BannerPages />}
      <AnimatePresence initial={false} exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/register" component={Register} />
          <Route path="/contact" component={Contact} />
          <Route component={NotFound} />
        </Switch>
      </AnimatePresence>
      <Footer />
    </>
  );
}
export default App;
